import { OperadorLogico } from "@shared/enums/OperadorLogico";

export class FiltroSeleccionado {
    id:             string;
    clave:          string;
    valor:          string;
    operadorLogico: OperadorLogico;
    activo:         boolean;
}